import * as React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useProvider } from "./hooks";
import { getThemeForProvider } from "./theme";

// This provider renders above the router, before the root loader's
// accountInfo exists, so it can only guess the provider from the ?provider=
// URL param / sessionStorage (see providerStorage) — RootRoute applies the
// authoritative, account-API-driven theme once that data is available.
function ProviderThemeProvider({ children }: { children: React.ReactNode }) {
  const provider = useProvider();
  const theme = React.useMemo(() => getThemeForProvider(provider), [provider]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default ProviderThemeProvider;
